(function () {
	const slideshow = () => {
		const slideshowSections = document.querySelectorAll(".slideshow-section");
		
		slideshowSections.forEach(function(section) {
			if (section.classList.contains('slider_started')){
				return;
			}
			
			section.classList.add('slider_started');
			
			const id = section.getAttribute("id");
			const box = section.querySelector(".slideshow");
			
			if (!box) return;
			
			const autoplay = box.getAttribute("data-autoplay") === "true";
			const stopAutoplay = box.getAttribute("data-stop-autoplay") === "true";
			const delay = parseFloat(box.getAttribute("data-delay")) || 3;
			const parallaxData = box.getAttribute("data-parallax");
			const speedData = parseFloat(box.getAttribute("data-speed")) || 1.1;
			const effectData = box.getAttribute("data-effect");
			
			let autoplayParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay * 1000,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}
			
			let swiperParms = {
				parallax: parallaxData,
				speed: speedData * 1000,
				effect: effectData,
				loop: true,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				creativeEffect: {
					prev: {
						shadow: true,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: true,
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};
			
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
			
			colorScheme(swiper);
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			
			function colorScheme(context) {
				const parent = context.el.parentElement;
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const activeSlideElement = activeSlide.querySelector(".slideshow-slide");
				
				if (!activeSlideElement) return;
				
				const colorScheme = activeSlideElement.getAttribute("data-color-scheme");
				const changeItems = [
					context.navigation.nextEl,
					context.navigation.prevEl,
					context.pagination.el,
				];
				
				changeItems.forEach((selector) => {
					if (selector) {
						const elements = document.querySelectorAll(selector);
						elements.forEach((item) => {
							item.classList.remove("color-background-1", "color-background-4");
							item.classList.add(colorScheme);
						});
					}
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
